// Dependencies install via npm
require('./bootstrap.js')

// External Scripts - TODO: externalize
require('@/external/jquery.daterangepicker')
require('@/external/colorpicker.js')
require('@/external/modal.js') // obsolete - already in bootstrap?
require('@/external/tab.js') // obsolete - already in bootstrap?

// Custom dependencies
require('./components/transition-event.js')
require('./components/selectize.js')
require('./components/loading-overlay.js')
require('./components/alert.js')
require('./components/briq-modal.js')
require('./components/drawer.js')
require('./components/briq-tab.js')
require('./components/account-menu.js')
require('./components/help-menu.js')
require('./components/planboard')
require('./components/save-button')
require('./components/dirty-modal')
require('./components/flatpickr')
require('./components/context-menu')
require('./components/locked-input')
require('./components/repeater')
require('./components/table')
require('./components/table-toolbar')
require('./components/sidebar')
require('./components/image-upload')
require('./components/autosubmit')
require('./components/password')
require('./components/ajax-form.js')
require('./components/ajax-link')
require('./components/fill-fields')
require('./components/activity-modal')
require('./components/empty-state')
require('./components/remove-button')
require('./components/ghost-row')
require('./components/plusmin')
require('./components/password-strength')
require('./components/avatar-preview')
require('./components/checkbox-button-group')
require('./components/tooltip')
require('./components/validate-required')
require('./components/reset-form')
require('./components/verify-code')
require('./components/select-all')
require('./components/collapse')
require('./components/participants')
require('./components/reports/operation-lists.js')

import $ from 'jquery'
import Inputmask from 'inputmask'

$(function() {
  const $body = $('body')

  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    },
  })

  $(document).ready(function() {
    if (process.env.NODE_ENV === 'development')
      console.log('%csetting bless timeout', 'color: green')
    setTimeout(function() {
      if (process.env.NODE_ENV === 'development') console.log('%ctriggering bless', 'color: green')
      $body.trigger('bless')
    }, 100)
  })
  if (process.env.NODE_ENV === 'development') {
    $body.on('bless', function() {
      console.log('%cbless was triggered', 'color: green')
    })
  }

  $('.button--icon--disabled').on('click', function(e) {
    e.preventDefault()
  })

  Inputmask().mask(document.querySelectorAll('input'))
})
